import { esc } from '../ui/modal';
import { t } from '../ui/lang';
/**
 * "Users Access" farm-settings tab — which operators of the farm's group are
 * granted access to the farm (a `user_farms` row). A checkbox list of the group's
 * operators (each preset to its `granted` flag); Save PUTs the exact set of checked
 * ids. Visible to admin+superadmin (the endpoint is farm-auth with an admin guard).
 */
export async function renderUsersAccessTab(panel, farmId) {
    panel.innerHTML = `
        <p class="settings-hint">${t('farms.users_access_hint')}</p>
        <div class="access-loading">${t('common.loading')}</div>
        <div class="users-access-wrap" style="display:none"></div>
        <div class="settings-error modal__error" style="display:none"></div>
        <div class="settings-actions"><button type="button" class="modal__submit users-access-save" style="display:none">${t('common.save')}</button></div>
    `;
    const loadingEl = panel.querySelector('.access-loading');
    const wrapEl = panel.querySelector('.users-access-wrap');
    const errorEl = panel.querySelector('.settings-error');
    const saveBtn = panel.querySelector('.users-access-save');
    let users;
    try {
        const r = await fetch(`/api/farms/${farmId}/access-users`);
        if (!r.ok)
            throw new Error((await r.json()).error ?? t('common.failed_to_load'));
        users = await r.json();
    }
    catch (err) {
        loadingEl.style.display = 'none';
        errorEl.textContent = err.message;
        errorEl.style.display = 'block';
        return;
    }
    loadingEl.style.display = 'none';
    wrapEl.style.display = 'block';
    if (users.length === 0) {
        wrapEl.innerHTML = `<p class="settings-hint">${t('farms.users_access_none')}</p>`;
        return;
    }
    wrapEl.innerHTML = `
        <div class="users-access-list">
            ${users.map((u) => `
                <label class="farm-assignment__item">
                    <input type="checkbox" data-user="${u.id}" ${u.granted ? 'checked' : ''} />
                    <span>${esc(u.login)}</span>
                </label>
            `).join('')}
        </div>
    `;
    saveBtn.style.display = '';
    saveBtn.addEventListener('click', async () => {
        saveBtn.disabled = true;
        errorEl.style.display = 'none';
        const userIds = Array.from(wrapEl.querySelectorAll('input[type="checkbox"]:checked')).map((cb) => Number.parseInt(cb.dataset['user'], 10));
        try {
            const r = await fetch(`/api/farms/${farmId}/access-users`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ userIds }),
            });
            if (!r.ok)
                throw new Error((await r.json()).error ?? t('common.failed_to_save'));
            const original = saveBtn.textContent;
            saveBtn.textContent = t('common.saved');
            setTimeout(() => { saveBtn.textContent = original; }, 1500);
        }
        catch (err) {
            errorEl.textContent = err.message;
            errorEl.style.display = 'block';
        }
        finally {
            saveBtn.disabled = false;
        }
    });
}
